export const columnsDataDevelopment = [
  {
    Header: "COMPORTEMENT",
    accessor: "COMPORTEMENT",
  },
  {
    Header: "ÉQUIPE A",
    accessor: "ÉQUIPE A",
  },
  {
    Header: "ÉQUIPE B",
    accessor: "ÉQUIPE B",
  },
  {
    Header: "ÉQUIPE C",
    accessor: "ÉQUIPE C",
  },
  {
    Header: "ÉQUIPE D",
    accessor: "ÉQUIPE D",
  },
 
];

export const columnsDataCheck = [
  {
    Header: "name",
    accessor: "name",
  },
  {
    Header: "PROGRESS",
    accessor: "progress",
  },
  {
    Header: "QUANTITY",
    accessor: "quantity",
  },
  {
    Header: "DATE",
    accessor: "date",
  },
];

export const columnsDataColumns = [
  {
    Header: "name",
    accessor: "name",
  },
  {
    Header: "PROGRESS",
    accessor: "progress",
  },
  {
    Header: "QUANTITY",
    accessor: "quantity",
  },
  {
    Header: "DATE",
    accessor: "date",
  },
];

export const columnsDataComplex = [
  
  {
    Header: "Rang",
    accessor: "rang",
  },
  {
    Header: "Scénario",
    accessor: "scénario",
  },
  {
    Header: "Mesure",
    accessor: "score",
  },
];
